import axios from 'axios';

//const backendUrl = process.env.VUE_APP_BACKEND_URL;
const backendUrlA = process.env.VUE_APP_ADMIN_URL;

// Chile — mismo UUID ya usado como default en PlanMaintainer.vue (this.newPlan.countryId).
// Se usa como país por defecto en los listados de servicios que todavía no tienen un
// selector de país en su UI, ya que `GET /plan-services/services` ahora exige `countryId`
// (ver contracts/admin-endpoints.md sección 4).
const DEFAULT_COUNTRY_ID = 'd1749b17-4f47-4501-af6b-54cfc99507ff';

export default class ServicesService {
  static getHeaders() {
    const token = JSON.parse(localStorage.getItem('accessToken'));
    return { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' };
  }

  static async getAllServices(countryId = DEFAULT_COUNTRY_ID, activeOnly = false) {
    const token = JSON.parse(localStorage.getItem('accessToken'));
    const activeParam = activeOnly ? '&active=true' : '';
    const response = await axios.get(
      `${backendUrlA}/plan-services/services?countryId=${countryId}${activeParam}`,
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );

    if (response.data.status === 'ok') {
      return { status: 'ok', data: response.data.data };
    } else {
      throw new Error(response.data.message);
    }
  }

  static async getAllIsolatedServices() {
    const accessToken = JSON.parse(localStorage.getItem('accessToken'));
    const response = await axios.get(`${backendUrlA}/services-records/isolated-services`, {
      headers: { Authorization: `Bearer ${accessToken}` }
    });

    if (response.data.status === 'ok') {
      return { status: 'ok', data: response.data.data };
    } else {
      throw new Error(response.data.message);
    }
  }

  static async getAllBenefits() {
    const token = JSON.parse(localStorage.getItem('accessToken'));
    const response = await axios.get(`${backendUrlA}/plan-services/benefits`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (response.data.status === 'ok') {
      return { status: 'ok', data: response.data.data };
    } else {
      throw new Error(response.data.message);
    }
  }

  // ---- Service — CRUD (Mantenedor de Servicios) ----

  static async createService(payload) {
    try {
      const response = await axios.post(`${backendUrlA}/services`, payload, {
        headers: this.getHeaders()
      });
      return { status: 'ok', data: response.data.data ?? response.data };
    } catch (error) {
      return { status: 'error', message: error.response?.data?.message };
    }
  }

  static async updateService(serviceId, payload) {
    try {
      const response = await axios.put(`${backendUrlA}/services/${serviceId}`, payload, {
        headers: this.getHeaders()
      });
      return { status: 'ok', data: response.data.data ?? response.data };
    } catch (error) {
      return { status: 'error', message: error.response?.data?.message };
    }
  }

  // ---- ServiceType — CRUD ----

  static async getServiceTypes() {
    try {
      const response = await axios.get(`${backendUrlA}/service-types`, {
        headers: this.getHeaders()
      });
      return { status: 'ok', data: response.data.data ?? response.data };
    } catch (error) {
      return { status: 'error' };
    }
  }

  static async createServiceType(payload) {
    try {
      const response = await axios.post(`${backendUrlA}/service-types`, payload, {
        headers: this.getHeaders()
      });
      return { status: 'ok', data: response.data.data ?? response.data };
    } catch (error) {
      return { status: 'error', message: error.response?.data?.message };
    }
  }

  static async updateServiceType(id, payload) {
    try {
      const response = await axios.put(`${backendUrlA}/service-types/${id}`, payload, {
        headers: this.getHeaders()
      });
      return { status: 'ok', data: response.data.data ?? response.data };
    } catch (error) {
      return { status: 'error', message: error.response?.data?.message };
    }
  }

  static async deleteServiceType(id) {
    try {
      await axios.delete(`${backendUrlA}/service-types/${id}`, {
        headers: this.getHeaders()
      });
      return { status: 'ok' };
    } catch (error) {
      return { status: 'error', message: error.response?.data?.message };
    }
  }

  // ---- ServicePlanDefault — CRUD (Defaults de Servicio por País) ----

  static async getServicePlanDefaults(serviceId) {
    try {
      const response = await axios.get(
        `${backendUrlA}/plan-services/service-plan-default/${serviceId}`,
        { headers: this.getHeaders() }
      );
      return { status: 'ok', data: response.data.data ?? response.data };
    } catch (error) {
      return { status: 'error' };
    }
  }

  static async createServicePlanDefault(payload) {
    try {
      const response = await axios.post(
        `${backendUrlA}/plan-services/service-plan-default`,
        payload,
        { headers: this.getHeaders() }
      );
      return { status: 'ok', data: response.data.data ?? response.data };
    } catch (error) {
      return { status: 'error', message: error.response?.data?.message };
    }
  }

  static async updateServicePlanDefault(id, payload) {
    try {
      const response = await axios.put(
        `${backendUrlA}/plan-services/service-plan-default/${id}`,
        payload,
        { headers: this.getHeaders() }
      );
      return { status: 'ok', data: response.data.data ?? response.data };
    } catch (error) {
      return { status: 'error', message: error.response?.data?.message };
    }
  }

  static async getServiceRequiredInputs(serviceId) {
    try {
      const response = await axios.get(
        `${backendUrlA}/services/${serviceId}/required-inputs`,
        { headers: this.getHeaders() }
      );
      return { status: 'ok', data: response.data.data };
    } catch {
      return { status: 'error' };
    }
  }
}
